var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-receipt-entries" },
    [
      _c(
        "b-row",
        [
          _c(
            "csp-desktop-info-card",
            {
              attrs: {
                cols: 12,
                icon: "inticon-autoclaim_billing",
                title: "Übersicht abzurechnende Artikel",
              },
            },
            [
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        title: "Artikel hinzufügen",
                        variant: "secondary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showCreationModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Artikel hinzufügen\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "record-receipt-entries-block" },
                [
                  _vm.isLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "loading-overlay d-flex justify-content-center pt-5",
                        },
                        [_c("csp-loading-indicator")],
                        1
                      )
                    : _vm.receiptItems.length === 0
                    ? _c(
                        "div",
                        { staticClass: "collapse-body" },
                        [
                          _c(
                            "b-alert",
                            {
                              staticClass: "mb-0",
                              attrs: { show: "", variant: "info" },
                            },
                            [
                              _vm._v(
                                "\n                        Es wurden keine zugeordneten Artikel gefunden.\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.receiptItems, function (receiptItem) {
                    return _c(
                      "b-card",
                      {
                        key: receiptItem.id,
                        staticClass: "mt-4",
                        attrs: { title: receiptItem.attributes.articleName },
                      },
                      [
                        _c("b-card-text", [
                          _c("div", { staticClass: "receipt-serviced-info" }, [
                            !receiptItem.attributes.dateCancelled
                              ? _c(
                                  "div",
                                  { staticClass: "right" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          title: "Artikel stornieren",
                                          variant: "secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showCancellationModal(
                                              receiptItem
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Artikel stornieren\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Artikelzuordnungs-ID: " +
                                  _vm._s(receiptItem.id)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Leistungsempfänger: " +
                                  _vm._s(
                                    receiptItem.attributes.serviceRecipientFirm
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Leistungsdatum: " +
                                  _vm._s(
                                    _vm.formatDate(
                                      receiptItem.attributes.serviceProvidedDate
                                    )
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                                Aktenfirma während Leistungserbringung: " +
                                  _vm._s(receiptItem.attributes.carDealerFirm) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Belegnummer: " +
                                  _vm._s(receiptItem.attributes.receiptNumber)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Belegpositions-ID: " +
                                  _vm._s(receiptItem.attributes.receiptItemId)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Buchungs-Vermerk: " +
                                  _vm._s(
                                    receiptItem.attributes.serviceProvidedNote
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            receiptItem.attributes.serviceProvidedInternalNote
                              ? _c("p", [
                                  _vm._v(
                                    "\n                                Interner Buchungshinweis: " +
                                      _vm._s(
                                        receiptItem.attributes
                                          .serviceProvidedInternalNote
                                      ) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          receiptItem.attributes.dateCancelled
                            ? _c(
                                "div",
                                { staticClass: "receipt-cancelled-info mt-1" },
                                [
                                  _c("p", [
                                    _c("b", [
                                      _vm._v("Artikel wurde storniert"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Stornierungsdatum: " +
                                        _vm._s(
                                          _vm.formatDate(
                                            receiptItem.attributes.dateCancelled
                                          )
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Stornobelegnummer: " +
                                        _vm._s(
                                          receiptItem.attributes
                                            .cancellationReceiptNumber
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Belegpositions-ID: " +
                                        _vm._s(
                                          receiptItem.attributes
                                            .cancellationReceiptItemId
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Artikelzuordnungs-ID: " +
                                        _vm._s(receiptItem.id)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Stornierungs-Vermerk: " +
                                        _vm._s(
                                          receiptItem.attributes
                                            .cancellationNote
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  receiptItem.attributes
                                    .cancellationInternalNote
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                                Interner Stornierungshinweis: " +
                                            _vm._s(
                                              receiptItem.attributes
                                                .cancellationInternalNote
                                            ) +
                                            "\n                            "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        "hide-footer": "",
                        size: "lg",
                        title: "Artikel stornieren",
                      },
                      on: {
                        close: function ($event) {
                          return _vm.hideCancellationModal()
                        },
                      },
                      model: {
                        value: _vm.isCancellationModalShown,
                        callback: function ($$v) {
                          _vm.isCancellationModalShown = $$v
                        },
                        expression: "isCancellationModalShown",
                      },
                    },
                    [
                      _vm.cancellationModalLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "loading-overlay d-flex align-items-center justify-content-center",
                            },
                            [_c("csp-loading-indicator")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.entryForCancellation
                        ? _c(
                            "div",
                            { staticClass: "receipt-entry-cancellation-modal" },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                            Artikelzuordnungs-ID: " +
                                    _vm._s(_vm.entryForCancellation.id) +
                                    "\n                            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                            Leistungsempfänger: " +
                                    _vm._s(
                                      _vm.entryForCancellation.attributes
                                        .serviceRecipientFirm
                                    ) +
                                    "\n                            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                            Leistungsdatum: " +
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.entryForCancellation.attributes
                                          .serviceProvidedDate
                                      )
                                    ) +
                                    "\n                            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                            Belegnummer: " +
                                    _vm._s(
                                      _vm.entryForCancellation.attributes
                                        .receiptNumber
                                    ) +
                                    "\n                            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                            Buchungs-Vermerk: " +
                                    _vm._s(
                                      _vm.entryForCancellation.attributes
                                        .serviceProvidedNote
                                    ) +
                                    "\n                            "
                                ),
                                _vm.entryForCancellation.attributes
                                  .serviceProvidedInternalNote
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                Interner Buchungshinweis:\n                                " +
                                          _vm._s(
                                            _vm.entryForCancellation.attributes
                                              .serviceProvidedInternalNote
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("b", [_vm._v("Stornierungsinformationen")]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                            Stornierungsdatum: " +
                                    _vm._s(new Date().toLocaleDateString()) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  staticClass:
                                    "receipt-entry-form info-card editMode",
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.cancelReceiptEntry.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("csp-form-group-textarea", {
                                    staticClass: "info-card-element",
                                    attrs: {
                                      form: _vm.cancellationForm,
                                      property: "internalNote",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("csp-form-group-textarea", {
                                    staticClass: "info-card-element",
                                    attrs: {
                                      form: _vm.cancellationForm,
                                      property: "note",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("csp-hide-for-group", {
                                    staticClass: "info-card-element",
                                    attrs: {
                                      form: _vm.cancellationForm,
                                      property: "hideForGroup",
                                      "record-id": _vm.recordId,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-action",
                                      attrs: { type: "submit" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Artikel stornieren\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        "hide-footer": "",
                        size: "lg",
                        title: "Artikel erstellen",
                      },
                      on: {
                        close: function ($event) {
                          return _vm.hideCreationModal()
                        },
                      },
                      model: {
                        value: _vm.isCreationModalShown,
                        callback: function ($$v) {
                          _vm.isCreationModalShown = $$v
                        },
                        expression: "isCreationModalShown",
                      },
                    },
                    [
                      _vm.creationModalLoading > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "loading-overlay d-flex align-items-center justify-content-center",
                            },
                            [_c("csp-loading-indicator")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "receipt-entry-booking-modal" },
                        [
                          _c("p", [
                            _c("b", [_vm._v("Artikel zu Akte hinzufügen:")]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            Leistungsdatum: " +
                                _vm._s(new Date().toLocaleDateString()) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              staticClass:
                                "receipt-entry-form info-card editMode",
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.createReceiptEntry.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("csp-form-group-select-searchable", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.creationForm,
                                  options: _vm.serviceRecipientFirmIdOptions,
                                  property: "serviceRecipientFirmId",
                                },
                                on: { change: _vm.loadArticleOptions },
                              }),
                              _vm._v(" "),
                              _c("csp-form-group-select-searchable", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.creationForm,
                                  options:
                                    _vm.invoicingModalityArticleIdOptions,
                                  property: "invoiceModalityArticleId",
                                },
                              }),
                              _vm._v(" "),
                              _c("csp-form-group-textarea", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.creationForm,
                                  property: "internalNote",
                                },
                              }),
                              _vm._v(" "),
                              _c("csp-form-group-textarea", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.creationForm,
                                  property: "note",
                                },
                              }),
                              _vm._v(" "),
                              _c("csp-hide-for-group", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.creationForm,
                                  property: "hideForGroup",
                                  "record-id": _vm.recordId,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-action",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(
                                    "\n                                Artikel hinzufügen\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }